module.exports = __webpack_public_path__ + "static/media/image-4.59a40863.png";